import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Rectangle, Space } from '@pitchero/react-ui';
import { isAssociated as isAssociatedSelector } from '../../../store/membership/selectors';
import { isLoggedIn as isLoggedInSelector } from '../../../store/auth/selectors';
import NoBackground from '../../club-frame/header/no-background';

import LandingPageCategory from './category';
import FilterBar from '../filter-bar';
import AssignmentList from '../assignments/list';
import AssignmentsLoginNotice from '../assignments/login-notice';
import NoProductsBanner from './no-products-banner';

const ShopLandingPage = ({
  categories,
  featuredProducts,
  overdueProducts,
  isAssociated,
  isLoading,
  isLoggedIn,
}) => (
  <>
    <NoBackground />
    <FilterBar selectedCategory="all" categories={categories} />
    {isAssociated && isLoggedIn && (
      <AssignmentList products={overdueProducts} canClose={featuredProducts.length > 0} />
    )}
    {featuredProducts.length > 0 && <Space bottom="small" />}
    {featuredProducts.map((featuredProductsCategory, index) => (
      <Rectangle
        fill={(index + 1) % 2 ? 'seashellgrey' : 'mercury'}
        key={featuredProductsCategory.name}
      >
        <LandingPageCategory isLoading={isLoading} {...featuredProductsCategory} />
      </Rectangle>
    ))}
    {isLoggedIn && !isAssociated && featuredProducts.length === 0 && <NoProductsBanner />}
    {!isLoggedIn && (
      <AssignmentsLoginNotice
        background={featuredProducts.length % 2 ? 'mercury' : 'seashellgrey'}
      />
    )}
  </>
);

ShopLandingPage.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  featuredProducts: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
        }),
      ),
    }),
  ).isRequired,
  overdueProducts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isAssociated: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  isLoggedIn: isLoggedInSelector(state),
  isAssociated: isAssociatedSelector(state, ownProps.clubId),
});

export default connect(mapStateToProps)(ShopLandingPage);
